module.exports = __webpack_public_path__ + "static/media/SU.3020cb47.png";